import { ToggleClass } from '../utils';
import { checkIfClickedInsideElement } from 'core/clickEventValidator'
import inView from 'in-view'
import { Observable } from 'rxjs'
//import { checkContentHeight } from '../pages/checkout/checkout.utils'

/**
 * Navigation
 *
 * @class Navigation
 */
export class Navigation {
  constructor() {
    this.overlay = document.querySelectorAll('.overlay');
    this.navMenuBackHistory = document.querySelectorAll('[data-click="back-history"]');
    this.navMenuBack = document.querySelectorAll('[data-click="back-page"]');
    this.navMenu = document.querySelector('.nav-menu:not(.nav-menu--full)');
    this.navMenuFull = document.querySelector('.nav-menu--full-category');
    this.navMenuSubCategory = document.querySelector(
      '.nav-menu--full__sub-category'
    );
    this.navSearch = document.querySelectorAll('[data-toggle="nav-search"]');
    this.navSearchResults = document.querySelector('.topbar-search-results');
    this.navSearchContainer = document.querySelector('.topbar-search__container');
    this.topbarSearchBack = document.querySelector(".topbar-search__icon--back");
    this.faixaApp = document.querySelector('.container-faixaApp')
    this.facilitaServicos = document.querySelectorAll('[data-click="facilita-servico"]');
    this.menuCategoria = document.querySelector('#menuCategoria')

    if(this.navMenu) {
      this.navMenuItems = Array.prototype.slice.call(
        this.navMenu.querySelectorAll('.nav-menu__item')
      );
      this.navMenuLevels = Array.prototype.slice.call(
        this.navMenu.querySelectorAll('.nav-menu__items--sub')
      );
      this.navMenuBackLevels = Array.prototype.slice.call(
        this.navMenu.querySelectorAll('[data-toggle="back-level"]')
      );
    }

    /* this.header = document.querySelector("#header");

    if(this.header)
      this.sticky = document.querySelector("#header").offsetTop; */

    this.init();
  }

  /**
   * Get level depth
   */
  getLevelDepth(el, index) {
    index = index || 0;
    if (el.classList.contains('nav-menu')) return index;
    if (el.classList.contains('nav-menu__items--sub')) index++;
    return el.parentNode && this.getLevelDepth(el.parentNode, index);
  }

  /**
   * Set sub levels depth
   */
  setNavMenuLevelDepth() {
    if(this.navMenuLevels) {
      Array.prototype.forEach.call(this.navMenuLevels, el =>
        el.setAttribute('data-level', this.getLevelDepth(el))
      );
    }
  }

  initEvents() {
    const toggleNavMenu = new ToggleClass(
      '[data-toggle="nav-menu"]',
      this.navMenu,
      undefined,
      undefined,
      undefined,
      true
    );

    const toggleNavMenuFull = new ToggleClass(
      '[data-toggle="nav-menu"]',
      this.navMenuFull,
      undefined,
      this.overlay,
      (e, isActive) => {
        if(!isActive){
          Array.prototype.forEach.call(this.overlay, el =>
            el.classList.remove('actived')
          );
          Array.prototype.forEach.call(document.querySelectorAll('.navbar__menu-item'), el =>
            el.classList.remove('actived')
          );
        }

        this.menuCategoria.addEventListener('mouseleave', event => {
          document.querySelector('.nav-menu--full-category').classList.remove('actived')
          document.querySelector('.navbar__menu-item').classList.remove('actived')
          document.querySelector('.overlay').classList.remove('actived')
        })

        if(this.navMenuFull.offsetHeight > window.innerHeight) {
          this.navMenuFull.style['height'] = `${(window.innerHeight - 100)}px`
          this.navMenuFull.style['overflow'] = 'auto'
        }
      },
      undefined
    );

    if(this.navMenuFull) {
      Array.prototype.forEach.call(this.navMenuFull.querySelectorAll('[data-category]'), item => {
        let category = item.getAttribute('data-category');
        let subCategory = this.navMenuSubCategory.querySelectorAll(
          '.nav-menu__items--sub'
        );

        item.addEventListener('mouseenter', event => {
          Array.prototype.forEach.call(subCategory, item => item.classList.remove('actived'));
          Array.prototype.forEach.call(this.navMenuFull.querySelectorAll('[data-category]'), item => item.classList.remove('actived'));
          item.classList.add('actived');
          this.navMenuSubCategory.querySelector(`[data-subcategory="${category}"]`).classList.add('actived');
        });
      });
    }

    /**
     * Create events to push sub levels
     */
    if(this.navMenuItems) {
      Array.prototype.forEach.call(this.navMenuItems, el => {
        let subLevel = el.querySelector('.nav-menu__items--sub');
        if (subLevel) {
          el.querySelector('a').addEventListener('click', event => {
            event.preventDefault();
            subLevel.classList.add('actived');
          });
        }
      });
    }

    /**
     * Create events to push back parent sub level
     */

    if(this.navMenuBackLevels) {
      Array.prototype.forEach.call(this.navMenuBackLevels, el => {
        let parentSubLevel = el.closest('.nav-menu__items--sub');
        if (parentSubLevel) {
          el.addEventListener('click', event => {
            event.preventDefault();
            parentSubLevel.classList.toggle('actived');
          });
        }
      });
    }

    /**
     * Create events to open search on input focus and esc
     */

    if(this.navSearch) {
      Array.prototype.forEach.call(this.navSearch, nav => {
        nav.addEventListener('focus', event => {
          document.addEventListener("click", searchClickElemetEventListener, false);
          document.addEventListener("keydown", closeSearchLayerESC, false);
        });

      })

      const searchClickElemetEventListener= (event) => {
        const check = checkIfClickedInsideElement(this.navSearchContainer, event.target);
        const checkBackArrow = checkIfClickedInsideElement(this.topbarSearchBack, event.target);

        //check if clicked inside back arrow
        if(checkBackArrow){
          closeSearchLayer(event);
          return;
        }

        if(check) openSearchLayer(event)
        else closeSearchLayer(event);
      }

      const openSearchLayer = (event) => {

        if(this.navSearchContainer && !this.navSearchContainer.classList.contains("actived") && this.navSearchResults) {
          this.navSearchContainer.classList.add("actived");
          this.navSearchResults.classList.add("actived");
          document.body.classList.add("block-scroll-filters");

          if(this.topbarSearchBack)
            this.topbarSearchBack.style.display = "block";

          Array.prototype.forEach.call(this.overlay, el =>
            el.classList.add('actived')
          );
        }

      }

      const closeSearchLayer = (event) => {

        if(this.navSearchContainer && this.navSearchResults) {
          this.navSearchContainer.classList.remove("actived");
          this.navSearchResults.classList.remove("actived");
          document.body.classList.remove("block-scroll-filters");

          if(this.topbarSearchBack)
            this.topbarSearchBack.style.display = "none";

          Array.prototype.forEach.call(this.overlay, el =>
            el.classList.remove('actived')
          );
        }

        document.removeEventListener("click", searchClickElemetEventListener, false);
        document.removeEventListener("keydown", closeSearchLayerESC, false);
      }

      const closeSearchLayerESC = (event) => {
        if (event.keyCode == 27) {
          closeSearchLayer(event);
        }
      }
    }

    /**
     * Create events to close search on ESC
     */

    /* const closeSearch = document.addEventListener('keydown', event => {
        if (event.keyCode == 27) {
            if(this.navSearch.classList.contains('actived'))
              this.navSearch.classList.remove('actived')

            if(document.body.classList.contains('block-scroll'))
              document.body.classList.remove('block-scroll')
        }
    }) */

     /**
     * Create events to back history
     */
    if(this.navMenuBackHistory) {
      Array.prototype.forEach.call(this.navMenuBackHistory, el => {
        el.addEventListener('click', event => {
          event.preventDefault();
          window.location.href="/panvel";
        });
      });
    }

    if(this.navMenuBack) {
      Array.prototype.forEach.call(this.navMenuBack, el => {
        el.addEventListener('click', event => {
          event.preventDefault();
          window.history.back();
        });
      });
    }

    if(this.facilitaServicos) {
      Array.prototype.forEach.call(this.facilitaServicos, el => {
        el.addEventListener('click', event => {
          event.preventDefault();
          el.classList.toggle("active");
        });
      });
    }

     /**
     * Create scrol event to set fixed header
     */
    /* if(this.sticky) {
      window.addEventListener('scroll', e => {
        if (window.pageYOffset > this.sticky) {
          header.classList.add("sticky");
        } else {
          header.classList.remove("sticky");
        }
      })
    } */

    /**
     * Create scrol event to set fixed button (checkout)
     */

    /* let scrollStream = Observable.fromEvent(window, 'scroll');
    scrollStream
      .filter(e => document.querySelector(".btn-flutuante"))
      .map(e => document.querySelector(".btn-flutuante"))
      .debounceTime(200)
      .subscribe(btn => {
        if (this.checkElementIsVisible(btn)) btn.classList.add("btn-checkout-fixed");
        if (!this.checkElementIsVisible(document.querySelector(".cesta-pedido-resumo"))) btn.classList.remove("btn-checkout-fixed");
        checkContentHeight();
      }) */

    /**
    * Faixa APP PANVEL
    */
    if(this.faixaApp) {
      document.body.classList.add("banner-download-app");
      let btnCLose = document.querySelector('.container-btnApp__close')

      btnCLose.addEventListener('click', e => {
        document.body.classList.remove("banner-download-app");
        this.faixaApp.classList.add('hide')
        const links = document.querySelector(".container-content.home");
        if(links) links.style = "padding-top:60px";

      })
      
      let btnDownload = document.querySelectorAll('.target_download')

      Array.prototype.forEach.call(btnDownload, el => {
        el.addEventListener('click', e => {
          var userAgent = navigator.userAgent || navigator.vendor || window.opera;

          if(/android/i.test(userAgent)) {
              window.location.replace('https://play.google.com/store/apps/details?id=br.com.dimed.panvel');
          }

          if(/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
              window.location.replace('https://itunes.apple.com/br/app/panvel-farm%C3%A1cia-e-perfumaria/id1039184023?mt=8');
          }
        })
      })
    }
  }

  init() {
    this.setNavMenuLevelDepth();
    this.initEvents();
    document.getElementsByTagName("body")[0].removeAttribute('style');
  }

  checkElementIsVisible(elem) {
    var rect = elem.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;

    return elemBottom >= window.innerHeight
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/nav.js